import React, { Component } from 'react';
import Loading from '../assets/loading.gif';
import classie from './js/classie.js';
import Highcharts from 'highcharts';
import $ from 'jquery';

import './css/Style.css';
import './css/normalize.css';
import './css/demo.css';
import './css/component.css';

require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/export-data')(Highcharts)

class Index extends Component {
  componentDidMount() {
    const { produto, parametro_1, parametro_2 } = this.props.match.params;

    var api_baseUrl = 'https://apiclima.inmet.gov.br';
    var api_tempo = 'https://apitempo.inmet.gov.br';
    var estacoes = [];
    var imagens = [];
    var imagem_atual;
    var rotate_delay = 500; // Tempo que cada imagem irá demorar para rodar quando der play (milessegundos)

    var isMenuOpen = false; // Controla se o menu está aberto

    function dynamicMenus(tipo) {
      $('#menu_GraficosClimatologicos').css('display', 'none');
      $('#menu_NormaisClimatologicas').css('display', 'none');
      $('#menu_VariacoesClimaticas').css('display', 'none');
      $('#menu_TSM').css('display', 'none');
      $('#menu_Precipitacao').css('display', 'none');
      $('#menu_Temperatura').css('display', 'none');
      $('#menu_PrognosticoTemperatura').css('display', 'none');
      $('#menu_PrognosticoPrecipitacao').css('display', 'none');
      $('#menu_FaixaTemperatura').css('display', 'none');
      $('#menu_FaixaPrecipitacao').css('display', 'none');

      if (tipo === 'GraficosClimatologicos') {
        $('#menu_GraficosClimatologicos').css('display', 'inline');
      } else if (tipo === 'NormaisClimatologicas') {
        $('#menu_NormaisClimatologicas').css('display', 'inline'); 
      } else if (tipo === 'VariacoesClimaticas') {
          $('#menu_VariacoesClimaticas').css('display', 'inline');
      } else if (tipo === 'TSM') {
        $('#menu_TSM').css('display', 'inline');
      } else if (tipo === 'prec') {
        $('#menu_Precipitacao').css('display', 'inline');
      } else if (tipo === 'temp') {
        $('#menu_Temperatura').css('display', 'inline');
      } else if (tipo === 'progt') {
        $('#menu_PrognosticoTemperatura').css('display', 'inline');
      } else if (tipo === 'progp') {
        $('#menu_PrognosticoPrecipitacao').css('display', 'inline');
      } else if (tipo === 'faixat') {
        $('#menu_FaixaTemperatura').css('display', 'inline');
      } else if (tipo === 'faixap') {
        $('#menu_FaixaPrecipitacao').css('display', 'inline');
      }
    }

      async function montarGrafico(nome_estacao, codigo_estacao, tipo, titulo, tgrafico, high) {
        var dados = [
          { name: '1931 - 1960', data: [], color: '#FF0000' },
          { name: '1961 - 1990', data: [], color: '#00FF00' },
          { name: '1991 - 2020', data: [], color: '#00B6FF' }
        ];
  
        
        // Dados da normal 1931 - 1960
        await $.get(`${api_tempo}/normais/consulta/2/${tipo}/${codigo_estacao}`, async function (_3160) {
          if (_3160)
            for (var i = 0; i < _3160.length - 1; i++)
              dados[0].data.push(parseFloat(_3160[i].VALOR));
  
          // Dados da normal 1961 - 1990
          await $.get(`${api_tempo}/normais/consulta/1/${tipo}/${codigo_estacao}`, function (_6190) {
            if (_6190)
              for (var i = 0; i < _6190.length - 1; i++)
                dados[1].data.push(parseFloat(_6190[i].VALOR));
          });
  
          // Dados da normal 1991 - 2010
          await $.get(`${api_tempo}/normais/consulta/8/${tipo}/${codigo_estacao}`, function (_9120) {
            if (_9120)
              for (var i = 0; i < _9120.length - 1; i++)
                dados[2].data.push(parseFloat(_9120[i].VALOR));
          });
  
          Highcharts.chart(`${high}`, {
            chart: {
              zoomType: 'xy',
              type: 'spline',
            },
            title: { text: 'Instituto Nacional de Meteorologia - INMET' },
            subtitle: { text: `${titulo} || Estação: ${nome_estacao}` },
            yAxis: { title: { text: `${tgrafico}` } },
            xAxis: {
              categories: ['Janeiro', 'Feveveiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
            },
            legend: { borderWidth: 2 },
            plotOptions: { series: { valueDecimals: 2 } },
            series: dados,
            responsive: {
              rules: [{
                condition: { maxWidth: 500 },
                chartOptions: {
                  legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                  }
                }
              }]
            }
          });
        });
      }

    function geraOptions(element, data, selecione = null, inicial = null, atributo_inicial = null) {
      var opt = document.createElement('option');
      if (!selecione) {
        opt.innerHTML = 'Selecione';
        element.append(opt);
      }
      for (var i = 0; i < data.length; i++) {
        opt = document.createElement('option');
        opt.value = data[i].sigla;
        opt.innerHTML = data[i].nome;

        if (inicial)
          if (atributo_inicial && data[i].sigla === atributo_inicial)
            opt.setAttribute('selected', 'selected');

        element.append(opt);
      }
    }

    function removeOption(element) {
      var elements = element.find('option');
      for (var i = 0; i < elements.length; i++)
        elements[i].remove();
    }

    function abrirMenu(bool) {
      if (bool) {
        classie.add(document.getElementById('menu'), 'gn-selected');
        classie.add(document.getElementById('wrapper'), 'gn-open-all');
        isMenuOpen = true;
      } else {
        classie.remove(document.getElementById('menu'), 'gn-selected');
        classie.remove(document.getElementById('wrapper'), 'gn-open-all');
        isMenuOpen = false;
      }
    }

    function montarValidades() {
      $('.validades').find('span').remove()
      $('.validades').find('br').remove()

      let produto = $('.produto').val();

      // Caso seja prognóstico remover a última validade 'probabilidade' repetida
      // for(var i = 0; i < ((produto === 'progp' || produto === 'progt') ? imagens.length - 1 : imagens.length); i++){
      // console.log(imagens, imagens.length)
      for (var i = 0; i < imagens.length; i++) {
        if (produto === 'progp' || produto === 'progt') {
          let mes = produto === 'progp' ? $('#menu_PrognosticoPrecipitacao .meses .active')[0].id : $('#menu_PrognosticoTemperatura .meses .active')[0].id
          let periodo = produto === 'progp' ? $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id : $('#menu_PrognosticoTemperatura .tipos .active')[0].id

          let meses = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

          let primeiro = meses[parseInt(mes)]
          let segundo = mes === '12' ? meses[1] : meses[parseInt(mes) + 1 > 12 ? parseInt(mes) - 11 : parseInt(mes) + 1]
          let terceiro = mes === '12' ? meses[2] : meses[parseInt(mes) + 2 > 12 ? parseInt(mes) - 10 : parseInt(mes) + 2]
          let quarto = mes === '12' ? meses[3] : meses[parseInt(mes) + 3 > 12 ? parseInt(mes) - 9 : parseInt(mes) + 3]

          if (periodo === 'Mensal') {
            if (i === 0)
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${primeiro}</font></span>`)
            else if (i === 4)
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${segundo}</font></span>`)
            else if (i === 8)
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${terceiro}</font></span>`)
            else if (i === 12)
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${quarto}</font></span>`)
          } else if (periodo === 'Trimestral') {
            if (i === 0)
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${segundo} / ${terceiro} / ${quarto}</font></span>`)
          } else if (periodo === 'Estendida') {
            if (i === 0) {
              $('.validades').append(`<span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${parseInt(mes) + 4 <= 12 ? meses[parseInt(mes) + 4] : meses[parseInt(mes) + 4 - 12]}</font></span>`)
            } else if (i === 2) {
              $('.validades').append(`<br /><br /><span style="border: 1px solid rgba(44, 44, 44, 0.2);"><font size="4" color="#0F4098">${parseInt(mes) + 5 <= 12 ? meses[parseInt(mes) + 5] : meses[parseInt(mes) + 5 - 12]}</font></span>`)
            }
          }

          if(periodo === 'Mensal' || periodo === 'Trimestral') {
            // A primeira imagem (validade) vem selecionada por padrão
            if (i === 0) {
              $('.validades').append(`<span class="validade active" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
              // Para esconder parametros que não serão usados
            } else if ((i >= 0 && i <= 2) || (i >= 4 && i <= 6) || (i >= 8 && i <= 10) || (i >= 12 && i <= 14)) {
              $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
            }

            if (i === 3 || i === 7 || i === 11) {
              $('.validades').append('<br /><br />')
            }
          } else if (periodo === 'Estendida') {
            if (i === 0) {
              $('.validades').append(`<span class="validade active" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
            } else  {
              $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
            }
          }


        } else if (produto === 'faixat' || produto === 'faixap') {
          if (i === 0) {
            $('.validades').append(`<span class="validade active" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">Limite Inferior</span>`)
          } else if (i === 1) {
            $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">Média</span>`)
          } else if (i === 2) {
            $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">Limite Superior</span>`)
          }
        } else {
          // A primeira imagem (validade) vem selecionada por padrão
          if (i === 0) {
            $('.validades').append(`<span class="validade active" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
          } else {
            $('.validades').append(`<span class="validade" id="${i}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${imagens[i].mes_extenso}</span>`)
          }
        }
      }
    }

    // Controla qual botão (de validade) está selecionado e remove a classe 'active' do anterior
    function controlActive(id) {
      $('.validade').removeClass('active');
      $(id).addClass('active');
    }

    function controlActiveOptions(menu, submenu, id) {
      $(`#${menu} .${submenu}`).removeClass('active')
      $(`#${menu} #${id}`).addClass('active');
    }

    async function montarEstacoes(estado) {
      await $.get(`${api_baseUrl}/estacoes/${estado}`, function (response) {
        estacoes = [];
        for (var i = 0; i < response.length; i++)
          estacoes.push({ 'sigla': response[i].CD_ESTACAO, 'nome': `${response[i].DC_NOME} (${response[i].CD_ESTACAO})` });
      });
    }

    async function init() {
      if (produto && parametro_1 && parametro_2) {
        if (produto === 'NormaisClimatologicas') {
          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/periodos/${produto}`, function (response) {
            removeOption($('#menu_NormaisClimatologicas .periodo'));
            removeOption($('#menu_NormaisClimatologicas .parametro'));
            geraOptions($('#menu_NormaisClimatologicas .periodo'), response, false, true, parametro_1);
          });

          await $.get(`${api_baseUrl}/parametros/${produto}/${parametro_1}`, function (response) {
            removeOption($('#menu_NormaisClimatologicas .parametro'));
            geraOptions($('#menu_NormaisClimatologicas .parametro'), response, false, true, parametro_2);
          });

          $('#NormaisClimatologicas').click();
        } else if (produto === 'VariacoesClimaticas') {
          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/parametros/${produto}/1921-2020`, function (response) {
            removeOption($('#menu_VariacoesClimaticas .parametro'));
            geraOptions($('#menu_VariacoesClimaticas .parametro'), response, false, true, parametro_2);
          });

          $('#VariacoesClimaticas').click();
        } else if (produto === 'GraficosClimatologicos') {
          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/estados`, function (response) {
            removeOption($('#menu_GraficosClimatologicos .estado'));
            removeOption($('#menu_GraficosClimatologicos .estacao'));
            geraOptions($('#menu_GraficosClimatologicos .estado'), response, false, true, parametro_1);
          });

          await montarEstacoes(parametro_1);
          removeOption($('#menu_GraficosClimatologicos .estacao'));
          geraOptions($('#menu_GraficosClimatologicos .estacao'), estacoes, false, true, parametro_2);

          $('#GraficosClimatologicos').click();
        } else {
          dynamicMenus('nenhum');

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response);
          });
        }
      } else if (produto) {
        if (produto === 'TSM') {
          var ano_parametro;
          var mes_parametro;

          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/anos/${produto}`, function (response) {
            ano_parametro = response[0];

            removeOption($('#menu_TSM .ano'));
            removeOption($('#menu_TSM .mes'));
            geraOptions($('#menu_TSM .ano'), response, false, true, ano_parametro.sigla);
          });

          await $.get(`${api_baseUrl}/parametros/${produto}/${ano_parametro.sigla}`, function (response) {
            mes_parametro = response.reverse()[0];

            geraOptions($('#menu_TSM .mes'), response, false, true, mes_parametro.sigla);
          });
          $.get(`${api_baseUrl}/${produto}/${ano_parametro.sigla}/${mes_parametro.sigla}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
            $('.controles').css('display', 'none');
          });
        } else if (produto === 'prec') {
          var metodo = null,
            ano = null,
            mes = null;
          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/metodos/${produto}`, function (response) {
            metodo = response[1];

            removeOption($('#menu_Precipitacao .metodo'));
            removeOption($('#menu_Precipitacao .ano'));
            removeOption($('#menu_Precipitacao .mes'));
            geraOptions($('#menu_Precipitacao .metodo'), response, false, true, metodo.sigla);
          });

          await $.get(`${api_baseUrl}/anos/${produto}/${metodo.sigla}`, function (response) {
            ano = response[0];

            removeOption($('#menu_Precipitacao .ano'));
            removeOption($('#menu_Precipitacao .mes'));
            geraOptions($('#menu_Precipitacao .ano'), response, false, true, ano.sigla);
          });

          await $.get(`${api_baseUrl}/meses/${produto}/${metodo.sigla}/${ano.sigla}`, function (response) {
            mes = response.reverse()[0];

            removeOption($('#menu_Precipitacao .mes'));
            geraOptions($('#menu_Precipitacao .mes'), response, false, true, mes.sigla);
          });

          $.get(`${api_baseUrl}/${produto}/${ano.sigla}/${metodo.sigla}/${('00' + mes.sigla).slice(-2)}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.controles').css('display', 'inline');
            $('.previsaoList').css('display', 'inline');
          });
        } else if (produto === 'temp') {
          // eslint-disable-next-line
          var metodo = null, ano = null, mes = null;
          dynamicMenus(produto);

          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });

          await $.get(`${api_baseUrl}/metodos/${produto}`, function (response) {
            metodo = response[0];

            removeOption($('#menu_Temperatura .metodo'));
            removeOption($('#menu_Temperatura .ano'));
            removeOption($('#menu_Temperatura .mes'));
            geraOptions($('#menu_Temperatura .metodo'), response, false, true, metodo.sigla);
          });

          await $.get(`${api_baseUrl}/anos/${produto}/${metodo.sigla}`, function (response) {
            ano = response[0];

            removeOption($('#menu_Temperatura .ano'));
            removeOption($('#menu_Temperatura .mes'));
            geraOptions($('#menu_Temperatura .ano'), response, false, true, ano.sigla);
          });

          await $.get(`${api_baseUrl}/meses/${produto}/${metodo.sigla}/${ano.sigla}`, function (response) {
            mes = response.reverse()[0];

            removeOption($('#menu_Temperatura .mes'));
            geraOptions($('#menu_Temperatura .mes'), response, false, true, mes.sigla);
          });

          $.get(`${api_baseUrl}/${produto}/${ano.sigla}/${metodo.sigla}/${('00' + mes.sigla).slice(-2)}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.controles').css('display', 'inline');
            $('.previsaoList').css('display', 'inline');
          });
        } else if (produto === 'progt') {
          await $.get(`${api_baseUrl}/produtos`, function (response) {
            geraOptions($('.produto'), response, false, true, produto);
          });
          dynamicMenus(produto);

          await controlActiveOptions('menu_PrognosticoTemperatura', 'tipo', parametro_1 === '0' ? 'Trimestral' : 'Mensal')
          let periodo = $('#menu_PrognosticoTemperatura .tipos .active')[0].id

          await $.get(`${api_baseUrl}/anos/${produto}/${periodo}`, async function (response) {
            await montarAnos('menu_PrognosticoTemperatura', response)
          });

          let ano = $('#menu_PrognosticoTemperatura .anos .active')[0].id
          await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
            await montarMeses('menu_PrognosticoTemperatura', response, true)
          });

          $('.submit').click()
        } else if (produto === 'progp') {
          if (parametro_1) {
            await $.get(`${api_baseUrl}/produtos`, function (response) {
              geraOptions($('.produto'), response, false, true, produto);
            });
            dynamicMenus(produto);

            await controlActiveOptions('menu_PrognosticoPrecipitacao', 'tipo', parametro_1 === '0' ? 'Trimestral' : 'Mensal')
            let periodo = $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id

            await $.get(`${api_baseUrl}/anos/${produto}/${periodo}`, async function (response) {
              await montarAnos('menu_PrognosticoPrecipitacao', response)
            });

            let ano = $('#menu_PrognosticoPrecipitacao .anos .active')[0].id
            await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
              await montarMeses('menu_PrognosticoPrecipitacao', response, true)
            });

            $('.submit').click()
          }
        }
      } else {
        dynamicMenus('nenhum');

        await $.get(`${api_baseUrl}/produtos`, function (response) {
          geraOptions($('.produto'), response);
        });
      }
      abrirMenu(true);
    }

    async function detectMobile() {
      if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)) {
        abrirMenu(false)
      }
    }

    function montarAnos(menu, anos) {
      $(`#${menu} .anos`).find('span').remove()
      $(`#${menu} .anos`).find('br').remove()

      for (let i = 0; i < anos.length; i++) {
        $(`#${menu} .anos`).append(`<span class="ano ${i === 0 ? 'active' : ''}" id="${anos[i].sigla}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${anos[i].nome}</span>`)
      }
    }

    function montarMeses(menu, meses, ultimo = false) {
      $(`#${menu} .meses`).find('span').remove()
      $(`#${menu} .meses`).find('br').remove()

      console.log(meses)

      for (let i = 0; i < meses.length; i++) {
        if(i+1 === meses.length){
          $(`#${menu} .meses`).append(`<span class="mes active" id="${meses[i].sigla}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${meses[i].nome}</span>`)
        }else{
          $(`#${menu} .meses`).append(`<span class="mes" id="${meses[i].sigla}" style="border: 1px solid rgba(44, 44, 44, 0.2);">${meses[i].nome}</span>`)
        }
        if (i % 5 === 0 && i !== 0) {
          $(`#${menu} .meses`).append('<br />')
        }
      }
    }

    $(document).ready(async function () {
      await init();
      await detectMobile()

      $('.produto').change(async function () {
        let produto = $('.produto').val();
        dynamicMenus(produto);

        if (produto === 'GraficosClimatologicos') {
          $.get(`${api_baseUrl}/estados`, function (response) {
            removeOption($('#menu_GraficosClimatologicos .estado'));
            removeOption($('#menu_GraficosClimatologicos .estacao'));
            geraOptions($('#menu_GraficosClimatologicos .estado'), response);
          });
        } else if (produto === 'NormaisClimatologicas') {
          $.get(`${api_baseUrl}/periodos/${produto}`, function (response) {
            removeOption($('#menu_NormaisClimatologicas .periodo'));
            removeOption($('#menu_NormaisClimatologicas .parametro'));
            geraOptions($('#menu_NormaisClimatologicas .periodo'), response);
          });
        } else if (produto === 'VariacoesClimaticas') {
          $.get(`${api_baseUrl}/parametros/${produto}/1991-2020`, function (response) {
            removeOption($('#menu_VariacoesClimaticas .parametro'));
            geraOptions($('#menu_VariacoesClimaticas .parametro'), response);
          });
        } else if (produto === 'TSM') {
          $.get(`${api_baseUrl}/anos/${produto}`, function (response) {
            removeOption($('#menu_TSM .ano'));
            removeOption($('#menu_TSM .mes'));
            geraOptions($('#menu_TSM .ano'), response);
          });
        } else if (produto === 'prec') {
          $.get(`${api_baseUrl}/metodos/${produto}`, function (response) {
            removeOption($('#menu_Precipitacao .metodo'));
            removeOption($('#menu_Precipitacao .ano'));
            removeOption($('#menu_Precipitacao .mes'));
            geraOptions($('#menu_Precipitacao .metodo'), response);
          });
        } else if (produto === 'temp') {
          $.get(`${api_baseUrl}/metodos/${produto}`, function (response) {
            removeOption($('#menu_Temperatura .metodo'));
            removeOption($('#menu_Temperatura .ano'));
            removeOption($('#menu_Temperatura .mes'));
            geraOptions($('#menu_Temperatura .metodo'), response);
          });
        } else if (produto === 'progt') {
          let periodo = $('#menu_PrognosticoTemperatura .tipos .active')[0].id
          await $.get(`${api_baseUrl}/anos/${produto}/${periodo}`, async function (response) {
            await montarAnos('menu_PrognosticoTemperatura', response)
          });

          let ano = $('#menu_PrognosticoTemperatura .anos .active')[0].id
          await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
            await montarMeses('menu_PrognosticoTemperatura', response)
          });

          $('.submit').click()
        } else if (produto === 'progp') {
          let periodo = $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id
          await $.get(`${api_baseUrl}/anos/${produto}/${periodo}`, async function (response) {
            await montarAnos('menu_PrognosticoPrecipitacao', response)
          });

          let ano = $('#menu_PrognosticoPrecipitacao .anos .active')[0].id
          await await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
            await montarMeses('menu_PrognosticoPrecipitacao', response)
          });

          $('.submit').click()
        } else if (produto === 'faixat') {
          $('.submit').click()
        } else if (produto === 'faixap') {
          $('.submit').click()
        }
      });

      $('#menu_FaixaTemperatura .tipos').on('click', '.tipo', async function () {
        await controlActiveOptions('menu_FaixaTemperatura', 'tipo', this.id)
        $('.submit').click()
      });

      $('#menu_FaixaTemperatura .meses').on('click', '.mes', async function () {
        await controlActiveOptions('menu_FaixaTemperatura', 'mes', this.id)
        $('.submit').click()
      });

      $('#menu_FaixaPrecipitacao .tipos').on('click', '.tipo', async function () {
        await controlActiveOptions('menu_FaixaPrecipitacao', 'tipo', this.id)
        $('.submit').click()
      });

      $('#menu_FaixaPrecipitacao .meses').on('click', '.mes', async function () {
        await controlActiveOptions('menu_FaixaPrecipitacao', 'mes', this.id)
        $('.submit').click()
      });

      $('#menu_PrognosticoTemperatura .tipos').on('click', '.tipo', async function () {
        controlActiveOptions('menu_PrognosticoTemperatura', 'tipo', this.id)

        let periodo = $('#menu_PrognosticoTemperatura .tipos .active')[0].id

        await $.get(`${api_baseUrl}/anos/progt/${periodo}`, function (response) {
          montarAnos('menu_PrognosticoTemperatura', response)
        });

        let ano = $('#menu_PrognosticoTemperatura .anos .active')[0].id
        await $.get(`${api_baseUrl}/meses/progt/${periodo}/${ano}`, function (response) {
          montarMeses('menu_PrognosticoTemperatura', response)
        });

        $('.submit').click()
      });

      $('#menu_PrognosticoTemperatura .anos').on('click', '.ano', async function () {
        await controlActiveOptions('menu_PrognosticoTemperatura', 'ano', this.id)

        let produto = $('.produto').val();
        let periodo = $('#menu_PrognosticoTemperatura .tipos .active')[0].id
        let ano = $('#menu_PrognosticoTemperatura .anos .active')[0].id

        await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
          await montarMeses('menu_PrognosticoTemperatura', response)
          $('.submit').click()
        });
      });

      $('#menu_PrognosticoTemperatura .meses').on('click', '.mes', async function () {
        await controlActiveOptions('menu_PrognosticoTemperatura', 'mes', this.id)
        $('.submit').click()
      });

      $('#menu_PrognosticoPrecipitacao .tipos').on('click', '.tipo', async function () {
        controlActiveOptions('menu_PrognosticoPrecipitacao', 'tipo', this.id)
        
        let periodo = $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id
        await $.get(`${api_baseUrl}/anos/progp/${periodo}`, function (response) {
          montarAnos('menu_PrognosticoPrecipitacao', response)
        });

        let ano = $('#menu_PrognosticoPrecipitacao .anos .active')[0].id
        await $.get(`${api_baseUrl}/meses/progp/${periodo}/${ano}`, function (response) {
          montarMeses('menu_PrognosticoPrecipitacao', response)
        });

        $('.submit').click()
      });

      $('#menu_PrognosticoPrecipitacao .anos').on('click', '.ano', async function () {
        await controlActiveOptions('menu_PrognosticoPrecipitacao', 'ano', this.id)

        let produto = $('.produto').val();
        let periodo = $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id
        let ano = $('#menu_PrognosticoPrecipitacao .anos .active')[0].id

        await $.get(`${api_baseUrl}/meses/${produto}/${periodo}/${ano}`, async function (response) {
          await montarMeses('menu_PrognosticoPrecipitacao', response)
          $('.submit').click()
        });
      });

      $('#menu_PrognosticoPrecipitacao .meses').on('click', '.mes', async function () {
        await controlActiveOptions('menu_PrognosticoPrecipitacao', 'mes', this.id)
        $('.submit').click()
      });

      $('#menu_Temperatura .metodo').change(function () {
        var produto = $('.produto').val();
        var metodo = $('#menu_Temperatura .metodo').val();
        $.get(`${api_baseUrl}/anos/${produto}/${metodo}`, function (response) {
          removeOption($('#menu_Temperatura .ano'));
          removeOption($('#menu_Temperatura .mes'));
          geraOptions($('#menu_Temperatura .ano'), response);
        });
      });

      $('#menu_Temperatura .ano').change(function () {
        var produto = $('.produto').val();
        var metodo = $('#menu_Temperatura .metodo').val();
        var ano = $('#menu_Temperatura .ano').val();
        $.get(`${api_baseUrl}/meses/${produto}/${metodo}/${ano}`, function (response) {
          removeOption($('#menu_Temperatura .mes'));
          geraOptions($('#menu_Temperatura .mes'), response);
        });
      });

      $('#menu_Precipitacao .metodo').change(function () {
        var produto = $('.produto').val();
        var metodo = $('#menu_Precipitacao .metodo').val();
        $.get(`${api_baseUrl}/anos/${produto}/${metodo}`, function (response) {
          removeOption($('#menu_Precipitacao .ano'));
          removeOption($('#menu_Precipitacao .mes'));
          geraOptions($('#menu_Precipitacao .ano'), response);
        });
      });

      $('#menu_Precipitacao .ano').change(function () {
        var produto = $('.produto').val();
        var metodo = $('#menu_Precipitacao .metodo').val();
        var ano = $('#menu_Precipitacao .ano').val();
        $.get(`${api_baseUrl}/meses/${produto}/${metodo}/${ano}`, function (response) {
          removeOption($('#menu_Precipitacao .mes'));
          geraOptions($('#menu_Precipitacao .mes'), response);
        });
      });

      $('#menu_GraficosClimatologicos .estado').change(async function () {
        var estado = $('#menu_GraficosClimatologicos .estado').val();
        await montarEstacoes(estado);
        removeOption($('#menu_GraficosClimatologicos .estacao'));
        geraOptions($('#menu_GraficosClimatologicos .estacao'), estacoes);
      });

      $('#menu_TSM .ano').change(function () {
        var produto = $('.produto').val();
        var ano = $('#menu_TSM .ano').val();
        $.get(`${api_baseUrl}/parametros/${produto}/${ano}`, function (response) {
          removeOption($('#menu_TSM .mes'));
          geraOptions($('#menu_TSM .mes'), response);
        });
      });

      $('#menu_NormaisClimatologicas .periodo').change(async function () {
        var produto = $('.produto').val();
        var periodo = $('#menu_NormaisClimatologicas .periodo').val();

        $.get(`${api_baseUrl}/parametros/${produto}/${periodo}`, function (response) {
          removeOption($('#menu_NormaisClimatologicas .parametro'));
          geraOptions($('#menu_NormaisClimatologicas .parametro'), response);
        });
      });
    });

    $('.submit').click(function (e) {
      $('.tableWrapper').css('display', 'none');
      $('#buttonModal').css('display', 'none');
      $('.previsaoList').css('display', 'none');
      $('.graficosClimatologicos').css('display', 'none');

      let produto = $('.produto').val();

      if (produto === 'GraficosClimatologicos') {
        var estado = $('#menu_GraficosClimatologicos .estado').html();
        var codigo_estacao = $('#menu_GraficosClimatologicos .estacao').val();
        var nome_estacao = $('#menu_GraficosClimatologicos .estacao option:selected').html();
        let tipo = ['N208','N201','N203','N202','N258','N416','N295','N292']
        let titulo = ['Gráfico Comparativo Precipitação Acumulada (mm)','Gráfico Comparativo Temperatura Máxima (°C)','Gráfico Comparativo Temperatura Média (°C)','Gráfico Comparativo Temperatura Mínima (°C)','Gráfico Comparativo Umidade Relativa (%)','Gráfico Comparativo Pressão Atmosférica (mb)','Gráfico Comparativo Evaporação Total (mm)','Gráfico Comparativo Insolação Total (Horas e Décimos)']
        let tgrafico = ['Valor da Precipitação Total','Temperatura Máxima','Temperatura Média','Temperatura Mínima','Umidade Relativa','Pressão Atmosférica','Evaporação Total','Insolação Total']
        let high = ['Precipitacao','TempMax','TempMed','TempMin','Umidade','ATM','Evaporacao','Insolacao']


        if (codigo_estacao && codigo_estacao !== 'Selecione' && estado && estado !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);

          $('#buttonModal').css('display', 'inline');
          $('.modal-content').empty();
          $('.modal-content').append(`
            <p>
              A Organização Meteorológica Mundial (OMM) define Normais como “valores médios calculados para um período relativamente longo e uniforme, compreendendo no mínimo três décadas consecutivas” e padrões climatológicos normais como “médias de dados climatológicos calculadas para períodos consecutivos de 30 anos. No caso de estações para as quais a mais recente Normal Climatológica não esteja disponível, seja porque a estação não esteve em operação durante o período de 30 anos ou por outra razão qualquer, Normais Provisórias podem ser calculadas. Normais Provisórias são médias de curto período, baseadas em observações que se estendam sobre um período mínimo de 10 anos.
            </p>
            <p>
              As informações aqui apresentadas abrangem todas as estações meteorológicas de superfície mantidas pelo INMET em operação durante os períodos 01/01/1931 a 31/12/1960 (em linha vermelha) e 01/01/1961 a 31/12/1990 (linha azul) e incluem todos os parâmetros meteorológicos disponíveis em comum a serem visualizados em forma de gráficos. Caso não haja interesse de comparar os dois períodos e ou mesmo visualizar apenas um período, basta clicar em cima da legenda do período localizado abaixo das curvas. Quando automaticamente o gráfico não gerar ou ficar oculto a linha para um dos períodos de referência, significa que não há valores mensais deste parâmetro para a estação solicitada pelo usuário. Na caixa PLANILHAS são disponibilizadas para “download” tabelas, em formato Excel, contendo os valores das normais climatológicas obtidos para os parâmetros analisados para o período de 1931-1960 e para o período de 1961-1990 ir no seguinte linK: Normais Climatológicas do Brasil 1961-1990.
            </p>`);
          for(let k=0; k<tipo.length; k++){
            montarGrafico(nome_estacao, codigo_estacao, tipo[k], titulo[k], tgrafico[k], high[k]);
          }
          $('.graficosClimatologicos').css('display', 'block');
        }
        $('.img').css('display', 'none');
        $('.tableWrapper').css('display', 'block');
      } else if (produto === 'NormaisClimatologicas') {
        var periodo = $('#menu_NormaisClimatologicas .periodo').val();
        var parametro = $('#menu_NormaisClimatologicas .parametro').val();

        if (parametro && parametro !== 'Selecione' && periodo && periodo !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);

          $.get(`${api_baseUrl}/${produto}/${periodo}/${parametro}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      } else if (produto === 'VariacoesClimaticas') {
        parametro = $('#menu_VariacoesClimaticas .parametro').val();

        if (parametro && parametro !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);

          $.get(`${api_baseUrl}/${produto}/1991-2020/${parametro}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      } else if (produto === 'TSM') {
        var ano = $('#menu_TSM .ano').val();
        var mes = $('#menu_TSM .mes').val();

        if (ano && ano !== 'Selecione' && mes && mes !== 'Selecione') {

          $.get(`${api_baseUrl}/${produto}/${ano}/${mes}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
            $('.img').css('display', 'inline');
          });
        }
      } else if (produto === 'prec') {
        var metodo = $('#menu_Precipitacao .metodo').val();
        // eslint-disable-next-line
        var ano = $('#menu_Precipitacao .ano').val();
        // eslint-disable-next-line
        var mes = $('#menu_Precipitacao .mes').val();

        if (metodo && metodo !== 'Selecione' && ano && ano !== 'Selecione' && mes && mes !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);

          $.get(`${api_baseUrl}/${produto}/${ano}/${metodo}/${('00' + mes).slice(-2)}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      } else if (produto === 'temp') {
        // eslint-disable-next-line
        var metodo = $('#menu_Temperatura .metodo').val();
        // eslint-disable-next-line
        var ano = $('#menu_Temperatura .ano').val();
        // eslint-disable-next-line
        var mes = $('#menu_Temperatura .mes').val();

        if (metodo && metodo !== 'Selecione' && ano && ano !== 'Selecione' && mes && mes !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);

          $.get(`${api_baseUrl}/${produto}/${ano}/${metodo}/${('00' + mes).slice(-2)}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      } else if (produto === 'progt') {
        let periodo = $('#menu_PrognosticoTemperatura .tipos .active')[0].id
        let mes = $('#menu_PrognosticoTemperatura .meses .active')[0].id
        let ano = $('#menu_PrognosticoTemperatura .anos .active')[0].id

        if (periodo && periodo !== 'Selecione' && ano && ano !== 'Selecione' && mes && mes !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);
          $.get(`${api_baseUrl}/${produto}/${ano}/${periodo}/${mes}`, function (response) {
            if (response.length > 0) {
              imagens = response; // Array global de imagem
              imagem_atual = 0; // Começa da primeira imagem encontrada

              $('.img').attr('src', imagens[imagem_atual].base64);
              montarValidades();
              $('.previsaoList').css('display', 'inline');
            }
          });
        }
      } else if (produto === 'progp') {
        let periodo = $('#menu_PrognosticoPrecipitacao .tipos .active')[0].id
        let mes = $('#menu_PrognosticoPrecipitacao .meses .active')[0].id
        let ano = $('#menu_PrognosticoPrecipitacao .anos .active')[0].id

        if (periodo && periodo !== 'Selecione' && ano && ano !== 'Selecione' && mes && mes !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);
          $.get(`${api_baseUrl}/${produto}/${ano}/${periodo}/${mes}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      } else if (produto === 'faixat') {
        let periodo = $('#menu_FaixaTemperatura .tipos .active')[0].id
        let mes = $('#menu_FaixaTemperatura .meses .active')[0].id

        $('.img').css('display', 'inline');
        $('.img').attr('src', Loading);
        $.get(`${api_baseUrl}/${produto}/2010/${periodo}/${('00' + mes).slice(-2)}`, function (response) {
          imagens = response; // Array global de imagem
          imagem_atual = 0; // Começa da primeira imagem encontrada

          $('.img').attr('src', imagens[imagem_atual].base64);
          montarValidades();
          $('.previsaoList').css('display', 'inline');
        });

      } else if (produto === 'faixap') {
        let periodo = $('#menu_FaixaPrecipitacao .tipos .active')[0].id
        let mes = $('#menu_FaixaPrecipitacao .meses .active')[0].id

        if (periodo && periodo !== 'Selecione' && mes && mes !== 'Selecione') {
          $('.img').css('display', 'inline');
          $('.img').attr('src', Loading);
          $.get(`${api_baseUrl}/${produto}/2010/${periodo}/${('00' + mes).slice(-2)}`, function (response) {
            imagens = response; // Array global de imagem
            imagem_atual = 0; // Começa da primeira imagem encontrada

            $('.img').attr('src', imagens[imagem_atual].base64);
            montarValidades();
            $('.previsaoList').css('display', 'inline');
          });
        }
      }
    });

    // Vai para a primeira imagem do array (menor validade)
    $('.primeiro').click(function (e) {
      imagem_atual = 0;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActive(imagem_atual);
    });

    // Vai para a imagem anterior do array (validade anterior disponivel)
    $('.anterior').click(function (e) {
      imagem_atual > 0 ? imagem_atual-- : imagem_atual = imagens.length - 1;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActive(imagem_atual);
    });

    // fica rodando o array de validades
    $(function () {
      var loop = null;

      $('.play').click(function () {
        $('.play').css('display', 'none'); // Esconde o botão de play
        $('.parar').css('display', 'inline'); // Mostra o botão de parar

        if (loop !== null) return; // Caso o botão de stop seja acionado o loop termina

        // Enquanto está com loop ativo, vai percorrendo todo o array de imagens
        loop = setInterval(function () {
          (imagem_atual < (imagens.length - 1)) ? imagem_atual++ : imagem_atual = 0;

          $('.img').attr('src', imagens[imagem_atual].base64);
          controlActive(imagem_atual);
        }, rotate_delay);
      });

      // botão de stop acionado
      $('.parar').click(function () {
        $('.parar').css('display', 'none'); // Mostra o botão de play
        $('.play').css('display', 'inline'); // Esconde o botão de parar

        clearInterval(loop);
        loop = null
      });
    });

    // Vai para a próxima imagem do array (próxima validade disponivel)
    $('.proximo').click(function (e) {
      imagem_atual < (imagens.length - 1) ? imagem_atual++ : imagem_atual = 0;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActive(imagem_atual);
    });

    // Vai para a última imagem do array (última validade disponivel)
    $('.ultimo').click(function (e) {
      imagem_atual = imagens.length - 1;
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActive(imagem_atual);
    });

    // Ao clicar em uma validade
    $('.validades').on('click', '.validade', function () {
      imagem_atual = this.id; // Imagem atual vira a validade selecionada
      $('.img').attr('src', imagens[imagem_atual].base64);
      controlActive(this); // Muda a classe 'active' da validade anterior para a nova
    });

    // Ativa o FullScreen
    $('.ativar-fullScreen').click(function (e) {
      $('.ativar-fullScreen').css('display', 'none');
      $('.previsaoList').css('max-height', '5%');
      $('.img').css('max-height', '85%');
      $('.img').css('height', '85%');

      // Esconde o topo do site, deixando só a imagem e os controladores
      var element = $("#containerFullScreen")[0];
      var tmp = element.mozRequestFullScreen || element.webkitRequestFullscreen || element.requestFullscreen;
      tmp.call(element);
    });

    $('#containerFullScreen').bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function (e) {
      var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      var event = state ? 'FullscreenOn' : 'FullscreenOff';

      if (event === 'FullscreenOff') {
        $('.ativar-fullScreen').css('display', 'inline');
        $('.img').css('max-height', '65%');
        $('.previsaoList').css('max-height', '20%');
      }
    });

    $('.tablinks').click(function () {
      var tab_tipo = this.classList[1];
      var anterior = $('.active').filter(`.${tab_tipo}`);
      var clickada = $(this).attr('name');

      anterior.removeClass('active').fadeIn(); // Desativar tab antes ativada
      $('#' + anterior.attr('name')).css('display', 'none'); // Esconde div anterior

      $(this).addClass('active'); // Ativar tab clickada
      $('#' + clickada).css('display', 'block'); // Mostrar tab clickada
    });

    // ========== INICIO MENU LATERAL ==========
    function mobilecheck() {
      var check = false;
      // eslint-disable-next-line
      (function (a) { if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    function gnMenu(el, options) {
      this.el = el;
      this._init();
    }

    gnMenu.prototype = {
      _init: function () {
        this.trigger = this.el.querySelector('a.gn-icon-menu');
        this.menu = this.el.querySelector('nav.gn-menu-wrapper');
        isMenuOpen = false;
        this.eventtype = mobilecheck() ? 'touchstart' : 'click';
        this._initEvents();

        var self = this;
        this.bodyClickFn = function () {
          // self._closeMenu();
          this.removeEventListener(self.eventtype, self.bodyClickFn);
        };
      },
      _initEvents: function () {
        var self = this;

        if (!mobilecheck()) {
          this.menu.addEventListener('mouseover', function (ev) {
            self._openMenu();
            document.addEventListener(self.eventtype, self.bodyClickFn);
          });
        }
        this.trigger.addEventListener(this.eventtype, function (ev) {
          ev.stopPropagation();
          ev.preventDefault();
          if (isMenuOpen) {
            self._closeMenu();
            document.removeEventListener(self.eventtype, self.bodyClickFn);
          }
          else {
            self._openMenu();
            document.addEventListener(self.eventtype, self.bodyClickFn);
          }
        });
        this.menu.addEventListener(this.eventtype, function (ev) { ev.stopPropagation(); });
      },
      _openIconMenu: function () {
        classie.add(this.menu, 'gn-open-part');
      },
      _closeIconMenu: function () {
        classie.remove(this.menu, 'gn-open-part');
      },
      _openMenu: function () {
        if (isMenuOpen) return;
        classie.add(this.trigger, 'gn-selected');
        isMenuOpen = true;
        classie.add(this.menu, 'gn-open-all');
        this._closeIconMenu();
      },
      _closeMenu: function () {
        if (!isMenuOpen) return;
        classie.remove(this.trigger, 'gn-selected');
        isMenuOpen = false;
        classie.remove(this.menu, 'gn-open-all');
        this._closeIconMenu();
      }
    }

    new gnMenu(document.getElementById('gn-menu'));
    // ========== FIM MENU LATERAL ==========

    // Código modal
    var modal = document.getElementById("modalObs");
    var btn = document.getElementById("buttonModal");
    var span = document.getElementsByClassName("close")[0];

    btn.onclick = function () { modal.style.display = "block"; }

    span.onclick = function () { modal.style.display = "none"; }

    window.onclick = function (event) { if (event.target === modal) { modal.style.display = "none"; } }
  }

  render() {
    return (
      <div className="App">
        <div className="container">
          <ul id="gn-menu" className="gn-menu-main">
            <li className="gn-trigger">
              {/* eslint-disable-next-line */}
              <a className="gn-icon-menu" id="menu">
                <span>Abrir / Fechar</span>
              </a>
              <nav className="gn-menu-wrapper" id="wrapper">
                <div className="gn-scroller">
                  <ul className="gn-menu">
                    <li><span>INMET :: Clima</span></li>
                    <hr />
                    <li><span>Produto: </span><select className="produto"></select></li>
                    <hr />

                    <div id="menu_GraficosClimatologicos">
                      <li><span>Estado:</span><select className="estado"></select></li>
                      <li><span>Estação:</span><select className="estacao"></select></li>
                      <hr />
                      <li><button className="submit" id="GraficosClimatologicos">Gerar Gráfico</button></li>
                    </div>

                    <div id="menu_NormaisClimatologicas">
                      <li><span>Período:</span><select className="periodo"></select></li>
                      <li><span>Mapas:</span><select className="parametro"></select></li>
                      <hr />
                      <li><button className="submit" id="NormaisClimatologicas">Gerar Imagem</button></li>
                    </div>

                    <div id="menu_VariacoesClimaticas">
                      <li><span>Mapas:</span><select className="parametro"></select></li>
                      <hr />
                      <li><button className="submit" id="VariacoesClimaticas">Gerar Imagem</button></li>
                    </div>

                    <div id="menu_TSM">
                      <li><span>Ano:</span><select className="ano"></select></li>
                      <li><span>Mês:</span><select className="mes"></select></li>
                      <hr />
                      <li><button className="submit" id="TSM">Gerar Imagem</button></li>
                    </div>

                    <div id="menu_Precipitacao">
                      <li><span>Tipo:</span><select className="metodo"></select></li>
                      <li><span>Ano:</span><select className="ano"></select></li>
                      <li><span>Mês:</span><select className="mes"></select></li>
                      <hr />
                      <li><button className="submit" id="Prec">Gerar Imagem</button></li>
                    </div>

                    <div id="menu_Temperatura">
                      <li><span>Tipo:</span><select className="metodo"></select></li>
                      <li><span>Ano:</span><select className="ano"></select></li>
                      <li><span>Mês:</span><select className="mes"></select></li>
                      <hr />
                      <li><button className="submit" id="Temp">Gerar Imagem</button></li>
                    </div>

                    <div id="menu_PrognosticoTemperatura">
                      <li className="li-options li-tipo">
                        <span>Tipo: </span>
                        <div className="tiposList">
                          <div className="tipos">
                            <span className="tipo active" id="Trimestral" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Trimestral</span>
                            <span className="tipo" id="Mensal" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Mensal</span>
                           {/* <span className="tipo" id="Estendida" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Estendida</span> */}
                          </div>
                        </div>
                      </li>

                      <li className="li-options li-ano">
                        <span>Ano: </span>
                        <div className="anosList">
                          <div className="anos"></div>
                        </div>
                      </li>

                      <li className="li-options li-mes">
                        <span>Mês de Realização: </span>
                        <div className="mesesList">
                          <div className="meses"></div>
                        </div>
                      </li>
                    </div>

                    <div id="menu_PrognosticoPrecipitacao">
                      <li className="li-options li-tipo">
                        <span>Tipo: </span>
                        <div className="tiposList">
                          <div className="tipos">
                            <span className="tipo active" id="Trimestral" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Trimestral</span>
                            <span className="tipo" id="Mensal" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Mensal</span>
                          {/*  <span className="tipo" id="Estendida" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Estendida</span> */}
                          </div>
                        </div>
                      </li>

                      <li className="li-options li-ano">
                        <span>Ano: </span>
                        <div className="anosList">
                          <div className="anos"></div>
                        </div>
                      </li>

                      <li className="li-options li-mes">
                        <span>Mês de Realização: </span>
                        <div className="mesesList">
                          <div className="meses"></div>
                        </div>
                      </li>
                    </div>

                    <div id="menu_FaixaTemperatura">
                      <li className="li-options li-tipo">
                        <span>Tipo: </span>
                        <div className="tiposList">
                          <div className="tipos">
                            <span className="tipo active" id="Trimestral" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Trimestral</span>
                            <span className="tipo" id="Mensal" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Mensal</span>
                          </div>
                        </div>
                      </li>

                      <li className="li-options li-mes">
                        <span>Mês de Realização: </span>
                        <div className="mesesList">
                          <div className="meses">
                            <span className="mes active" id="1" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Janeiro</span>
                            <span className="mes" id="2" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Fevereiro</span>
                            <span className="mes" id="3" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Março</span>
                            <span className="mes" id="4" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Abril</span>
                            <span className="mes" id="5" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Maio</span>
                            <br />
                            <span className="mes" id="6" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Junho</span>
                            <span className="mes" id="7" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Julho</span>
                            <span className="mes" id="8" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Agosto</span>
                            <span className="mes" id="9" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Setembro</span>
                            <span className="mes" id="10" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Outubro</span>
                            <br />
                            <span className="mes" id="11" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Novembro</span>
                            <span className="mes" id="12" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Dezembro</span>
                          </div>
                        </div>
                      </li>
                    </div>

                    <div id="menu_FaixaPrecipitacao">
                      <li className="li-options li-tipo">
                        <span>Tipo: </span>
                        <div className="tiposList">
                          <div className="tipos">
                            <span className="tipo active" id="Trimestral" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Trimestral</span>
                            <span className="tipo" id="Mensal" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Mensal</span>
                          </div>
                        </div>
                      </li>

                      <li className="li-options li-mes">
                        <span>Mês de Realização: </span>
                        <div className="mesesList">
                          <div className="meses">
                            <span className="mes active" id="1" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Janeiro</span>
                            <span className="mes" id="2" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Fevereiro</span>
                            <span className="mes" id="3" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Março</span>
                            <span className="mes" id="4" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Abril</span>
                            <span className="mes" id="5" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Maio</span>
                            <br />
                            <span className="mes" id="6" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Junho</span>
                            <span className="mes" id="7" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Julho</span>
                            <span className="mes" id="8" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Agosto</span>
                            <span className="mes" id="9" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Setembro</span>
                            <span className="mes" id="10" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Outubro</span>
                            <br />
                            <span className="mes" id="11" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Novembro</span>
                            <span className="mes" id="12" style={{ border: '1px solid rgba(44, 44, 44, 0.2)' }}>Dezembro</span>
                          </div>
                        </div>
                      </li>
                    </div>

                  </ul>
                </div>
              </nav>
            </li>
            <li className="inmetName"><a href="https://portal.inmet.gov.br/">Instituto Nacional de Meteorologia</a></li>
          </ul>

          <div id="containerFullScreen">
            <div className="imgWrapper">
              <img className="img" alt="" />
              <div className="tableWrapper">
                {/* INICIO MODAL */}
                <button id="buttonModal">Instrução</button>
                <div id="modalObs" className="modal">
                  <div className="modal-content">
                    <span className="close">&times;</span>
                  </div>
                </div>
                {/* FIM MODAL */}
                {/* INICIO GRAFICOS */}
                <div className="graficosClimatologicos" id="graficosClimatologicos">
                  <div className="tab">
                    <button className="tablinks gc active" name="Precipitacao">Precipitação Acumulada</button>
                    <button className="tablinks gc" name="TempMax">Temperatura Máxima</button>
                    <button className="tablinks gc" name="TempMed">Temperatura Média</button>
                    <button className="tablinks gc" name="TempMin">Temperatura Mínima</button>
                    <button className="tablinks gc" name="Umidade">Umidade Relativa</button>
                    <button className="tablinks gc" name="ATM">Pressão ATM</button>
                    <button className="tablinks gc" name="Evaporacao">Evaporação</button>
                    <button className="tablinks gc" name="Insolacao">Insolação</button>
                  </div>

                  <div id="Precipitacao" className="tabcontent" style={{ display: 'block' }}></div>
                  <div id="TempMax" className="tabcontent"></div>
                  <div id="TempMed" className="tabcontent"></div>
                  <div id="TempMin" className="tabcontent"></div>
                  <div id="Umidade" className="tabcontent"></div>
                  <div id="ATM" className="tabcontent"></div>
                  <div id="Evaporacao" className="tabcontent"></div>
                  <div id="Insolacao" className="tabcontent"></div>
                </div>
                {/* FIM GRAFICOS */}
              </div>
            </div>
            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
            <div className="previsaoList">
              {/* <span className="primeiro"><FontAwesomeIcon icon={faFastBackward} size="2x" /></span>
              <span className="anterior"><FontAwesomeIcon icon={faBackward} size="2x" /></span>
              <span className="play"><FontAwesomeIcon icon={faPlay} size="2x" /></span>
              <span className="parar"><FontAwesomeIcon icon={faStop} size="2x" /></span>
              <span className="proximo"><FontAwesomeIcon icon={faForward} size="2x" /></span>
              <span className="ultimo"><FontAwesomeIcon icon={faFastForward} size="2x" /></span>
              <br /><br /> */}
              <span className="ativar-fullScreen"><font size="5">Tela Cheia</font></span>
              <br /><br />
              <div className="validades"></div>
            </div>
            {/* ========== INICIO CONTROLADORES DA IMAGEM ========== */}
          </div>
        </div>
      </div>
    );
  }
}
export default Index;

